export enum ShareStatus {
    PENDING = 'pending',
    UPLOADED = 'uploaded',
    DELIVERED = 'delivered',
    EXPIRED = 'expired',
    COMPLETED = 'completed',
    FAILED = 'failed',
}

export interface RecipientKeyRef {
    clientId: string;
    publicKeyPem: string;
    fingerprint: string;
}

export interface InvalidRecipient {
    clientId: string;
    reason: string;
}

export interface OperationShareInfo {
    recipients: RecipientKeyRef[];
    invalidRecipients: InvalidRecipient[];
}
